var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"page",attrs:{"fluid":"","id":"template"}},[_c('h1',[_vm._v(_vm._s(this.page.title))]),_c('p',{staticClass:"text-break",domProps:{"innerHTML":_vm._s(this.page.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }